<template>
  <div class="contentHome">
    <div class="centerPage">
      <tabCommon></tabCommon>
      <div class="right">
        <div class="title flex">
          <span>心理咨询</span>
          <div class="btnTab">
            <el-button size="mini" @click="choose($event,0)" class="activeIndex">全部({{ calc.all }})</el-button>
            <el-button size="mini" @click="choose($event,1)" class="">待付款({{ calc.unpay }})</el-button>
            <el-button size="mini" @click="choose($event,2)" class="">待通话({{ calc.unchat }})</el-button>
            <el-button size="mini" @click="choose($event,3)" class="">已完成({{ calc.done }})</el-button>
          </div>
        </div>
        <div class="formUserInfo">
          <div class="cnHomeTabsItem flex"
               v-for="(obj,index) in appointList"
               :key="index">
            <div class="avatar img" :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
            <div class="rightHome">
              <div class="flex">
                <span>医师：{{ obj.doctorName }}</span>
                <span>预约号：{{ obj.appointNo }}</span>
              </div>
              <p>
                <span class="time">预约时间：{{ obj.appointDateShow }}</span>
                <template v-if="obj.appointState == 1 && obj.operateCode=='patient_update'">
                  <span class="cost">等待修改确认</span>
                </template>
                <template v-else>
                  <span class="cost" v-if="obj.state==1">待付款</span>
                  <span class="cost" v-else-if="obj.state==2">待通话</span>
                  <span class="cost" v-else-if="obj.state==4">待分析</span>
                  <span class="green" v-else-if="obj.state==3">已完成</span>
                  <span style="color: #BBBBBB" v-else-if="obj.state==5">已失效</span>
                  <span style="color: #BBBBBB" v-else-if="obj.state==6">已取消</span>
                </template>
                <!--								<span :class="obj.payState==0?'cost':'green'">-->
                <!--									{{obj.state==1?'待付款':obj.state==2?'待通话':obj.state==3?'已完成':'已取消'}}-->
                <!--								</span>-->
              </p>
              <div class="flex">
                <span>咨询费用：<span class="cost">￥{{ obj.payAmount }}</span></span>
                <div>

                  <el-button v-if="obj.operateCode=='doctor_update'"
                             @click="toConfirm(obj.id)" size="mini" class="solid warn">
                    修改申请
                  </el-button>
                  <el-button v-if="obj.operateCode=='doctor_reject'"
                             @click="read(obj.id)" size="mini" class="solid warn">
                    修改被拒
                  </el-button>
                  <el-button v-if="obj.state==1" @click="toPay(obj.id)" size="mini" class="solid">
                    去付款
                  </el-button>
                  <shortChat class="solid" :user-id="obj.doctorId" v-if="obj.state==2"></shortChat>
                  <!--                  <el-button v-if="obj.state==2" @click="toConsult(obj.id)" size="mini" class="solid">
                                     私信
                                    </el-button>-->
                  <el-button v-if="obj.state==2" @click="toConsult(obj.id)" size="mini" class="solid">
                    去咨询
                  </el-button>

                  <el-button @click="toDetail(obj.id)" size="mini" class="solid">查看详情</el-button>
                  <!--                  自己修改-->
                  <el-button @click="handleCommand({command:'update',id:obj.id,doctorAccount:obj.doctorAccount})"
                             size="mini" class="solid"
                             v-if="obj.appointState===1">修改预约
                  </el-button>
                  <el-button @click="handleCommand({command:'cancel',id:obj.id, payState: obj.payState})" size="mini"
                             class="solid warn"
                             v-if="obj.appointState===1||obj.state==1">取消预约
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="empty" v-if="appointList.length==0">
            <img src="../../assets/img/no.png" alt="" width="200">
            <p>这里什么都没有</p>
          </div>
          <el-pagination
              class="pagination"
              background
              prev-text="Prev"
              next-text="Next"
              @size-change="handleChange"
              @current-change="handleChange"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>


    <updateApprove ref="updateApprove"></updateApprove>
    <updateReject ref="updateReject"></updateReject>
    <updateAppoint ref="updateAppoint"></updateAppoint>
    <cancelAppoint ref="cancelAppoint"></cancelAppoint>

  </div>
</template>

<script>
import base from '@/api/common';
import {getAxios, postAxios} from "@/api/http";
import {dropdown, dropdownItem, dropdownMenu} from 'element-ui';

export default {
  name: "psychologicalCounseling",
  data() {
    return {
      page: {
        current: 1,
        size: 5,
        total: 0
      },
      appointList: [],
      calc: {},
      state: 0,
      //countList: [{"name": "全部"}, {"name": "待付款"}, {"name": "待通话"}, {"name": "已完成"}],// 分类统计
    }
  },
  inject: ['reload'],
  components: {
    'tabCommon': () => import('./tabCommon'),
    [dropdown.name]: dropdown,
    [dropdownMenu.name]: dropdownMenu,
    [dropdownItem.name]: dropdownItem,
    'updateApprove': _ => import('./components/update-approve'),
    'updateReject': _ => import('./components/update-reject'),
    'updateAppoint': _ => import('./components/update-appoint'),
    'cancelAppoint': _ => import('./components/cancel-appoint'),
    'shortChat': _ => import('../common/shortChat'),
  },
  methods: {
    beforeHandleCommand(command, id) {
      return {
        command: command,
        id: id
      }
    },
    handleCommand(command) {
      let vm = this;
      if (command.command == 'update') {
        // 修改预约
        getAxios(base.api.appoint.toUpdate.replace("{id}", command.id))
            .then((res) => {
              if (res.data.status == 'success') {
                this.$refs.updateAppoint.$data.dialogVisible = true;
                this.$refs.updateAppoint.$data.appointId = command.id;
                // this.$refs.updateAppoint.$data.appointArr = res.data.appointArr;
                this.$refs.updateAppoint.$data.doctorAccount = command.doctorAccount;
                this.$refs.updateAppoint.$data.selectedNumLimit = res.data.selectedNumLimit;
                this.$refs.updateAppoint.initData();
              } else {
                this.$message.warning(res.data.message)
              }
            })
      } else if (command.command == 'cancel') {
        // 取消预约
        getAxios(base.api.appoint.toCancel.replace("{id}", command.id))
            .then((res) => {
              if (res.data.status == "success") {
                this.$refs.cancelAppoint.initData(command.id, command.payState);
              } else {
                this.$message.warning(res.data.message)
              }
            })
      }

    },
    toConfirm(id) {
      this.$refs.updateApprove.getData(id);
    },
    read(id) {
      this.$refs.updateReject.getData(id);
    },
    toUpdate(id) {
      postAxios(base.api.toUpdate.replace('{id}', id)).then((res) => {
        //console.log(res)
      })
    },
    toPay(id) {
      this.$router.push('/user/order/' + id)
    },
    toConsult(id) {
      this.$router.push('/chat/' + id)
    },
    choose(event, state) {
      $('.activeIndex').removeClass('activeIndex');
      $(event.currentTarget).addClass('activeIndex');
      this.state = state;
      this.page.current = 1;// 重置页数
      this.getData(state);
    },
    toDetail(id) {
      this.$router.push('/user/counsel/' + id)
    },
    handleChange(val) {
      this.page.current = val;
      this.getData(this.state)
    },
    getData(state) {
      let vm = this;
      vm.appointList = [];
      vm.$ajax.get(base.api.user.appoints.replace('{pg}', vm.page.current).replace('{ps}', vm.page.size), {params: {state: state}})
          .then((res) => {
            if (res.data.status == 'success') {
              res.data.data.records.forEach((item) => {

                item.appointDateShow = base.utils.buildShowDate(item.appointStartLongtime, item.appointEndLongtime);

                if (item.payState == 0) {
                  if (item.appointState == 0) {
                    item.state = 1;//未支付
                  } else {
                    item.state = 5;//已失效-支付超时
                  }
                } else {
                  switch (item.appointState) {
                    case 1:
                      item.state = 2;//待咨询
                      break;
                    case 2:
                      item.state = 5;//已失效-支付超时
                      break;
                    case 3:
                      item.state = 4;//待分析
                      break;
                    case 4:
                      item.state = 3;//已完成
                      break;
                    case 5:
                      item.state = 6; //已取消
                      break;
                  }
                }
              });
              vm.appointList = res.data.data.records;
              vm.page.current = res.data.data.current;
              vm.page.total = res.data.data.total;
            }
          })
    },
    getCalc() {
      let vm = this;
      vm.$ajax.get(base.api.user.appointCalc)
          .then((res) => {
            vm.calc = res.data
          })
    },
  },
  mounted() {
    this.getData(0)
    this.getCalc()
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.dropdown-detail {
  margin-left: 5px;
}
</style>
